import { API_ROUTES, ApiService } from '@shared/api-utils';
import { FIVE_MINUTES_IN_SECONDS, getConfig } from '@shared/utils';
import type { CRMPromoLandingPagePayload } from '../types.ts';

const REVALIDATE_IN_SECONDS = FIVE_MINUTES_IN_SECONDS;

async function getPromoLandingPageData(slug: string): Promise<CRMPromoLandingPagePayload> {
  const { apiUrl, apiLocale } = getConfig();
  const apiService = ApiService.getInstance(apiUrl, 'omit');
  const route = API_ROUTES.CRM_LANDING_PAGES.replace(':slug', slug);

  try {
    const response = await apiService.get<CRMPromoLandingPagePayload>(route, {
      params: { locale: apiLocale },
      next: { revalidate: REVALIDATE_IN_SECONDS },
    });

    if (response.error || !response.data) {
      throw response.error || new Error('No data returned from API');
    }

    const data = response.data;
    const first = data.list?.[0];
    if (!first?.template) {
      throw new Error('Invalid CRM landing page payload: empty list or missing template');
    }

    return data;
  } catch {
    throw new Error(`No fallback data available for slug: ${slug}`);
  }
}

export { getPromoLandingPageData, REVALIDATE_IN_SECONDS };
